import React from "react";
import Header1 from './Header1'
import Header2 from "./Header2";
import Header3 from "./Header3";
import Body1 from "./Body1";
import Body3 from "./Body3";
import Footer1 from "./Footer1";
import Footer2 from "./Footer2";


function PageHome() {

  return (
    <div>
      <Header1/>
      <Header2/>
      <Header3/>
      <Body1/>
      
      <Body3/>
      <Footer1/>
      <Footer2/>
    </div>
  );
}

export default PageHome;
